import { BonusActionTypes } from './bonus.types'

const { SET_BONUSES } = BonusActionTypes

export const setBonuses = bonuses => ({
  type: SET_BONUSES,
  payload: bonuses
})
